import TitleBox from "../../components/Common/TitleBox";
import ContractTemplateEditBoard from "../../components/ContractTemplate/ContractTemplateEditBoard";

function ContractTemplatEdit() {
  return (
    <div>
      <TitleBox title="게약서 양식" />
      <ContractTemplateEditBoard />
    </div>
  );
}

export default ContractTemplatEdit;
